export default "__VITE_ASSET__acdcd49b__"